import { SiGithub, SiGoogle, SiX } from '@icons-pack/react-simple-icons';
import type { Provider } from '@supabase/supabase-js';

export const socialProviders: {
  name: string;
  icon: typeof SiGithub;
  id: Provider;
}[] = [
  {
  name: 'Google',
  icon: SiGoogle,
  id: 'google',
},
  {
    name: 'Github',
    icon: SiGithub,
    id: 'github',
  },

];
